import vue from '../main'
import { commonAddMouth } from "@/utils/function";
import * as zhongyi from './thirdParty/zhongyi'

let _this = vue;
let uniqueFalg
//中意标识
let zy = 'zhongyi'
//获取保险公司详情
export async function InsuranceCompanyDetail(id) {
    let sendData = {
        id: id
    }
    await _this.$api.Insurance.CompanyDetail(sendData).then((res) => {
        if (res.error === false) {
            uniqueFalg = res.data.uniqueFalg
        } else {
            _this.$message.error(res.msg);
        }
    });
}

//登录
export function login($this) {
    if (uniqueFalg == zy) {
        zhongyi.login($this)
    }

}
// 注册
export function register($this) {
    if (uniqueFalg == zy) {
        zhongyi.register($this)
    }

}

// 登录并注册
export function reg_log($this) {
    if (uniqueFalg == zy) {
        zhongyi.reg_log($this)
    }

}

// 暂存信息
export function SaveData($this) {
    $this.$confirm("确认保存订单信息吗?", "提示", {
        confirmButtonText: "确 认",
        cancelButtonText: "关 闭",
        type: "warning",
    }).then(() => {
        // $this.submitLoading = true;
        let sendData = {
            insuredCompanyId: $this.form.insuredCompanyId,
            insuredCompanyName: $this.$refs.myCompany.selected.label,
            insureProductCompanyName: $this.detail.insuranceCompanyName,
            insureProductCompanyId: $this.detail.insuranceCompanyId,
            passivityInsuredCompanyId: $this.form.passivityInsuredCompanyId,
            passivityInsuredCompanyName: $this.$refs.myCompany2.selected.label,
            thirdlyProductId: $this.detail.thirdlyId,
            startDate: $this.form.startDate,
            ProductExpandInfo: $this.detail.sumInsured || $this.detail.productExpandInfo,
            endDate:
                $this.form.insureWay == "2"
                    ? commonAddMouth($this.form.startDate, 12, 0)
                    : commonAddMouth($this.form.startDate, 1, 0),
            insuranceProductId:
                $this.type != 1 ? $this.detail.id : $this.detail.insuranceProductId,
            insureWay: $this.form.insureWay,
            insureWayText: $this.form.insureWay == 2 ? "年" : "月",
            insuranceOrderTheInsuredList: $this.tableData,
            state: 0,
        };
        if ($this.$route.query.id) {
            sendData.id = $this.$route.query.id;
        }
        $this.$api.Insurance.SaveData(sendData).then((res) => {
            if (res.error === false) {
              
                $this.$message.success("保存成功");
                $this.$router.replace("/insuranceOrders");
            } else {
                $this.$message.error(res.msg);
            }
        });
    });
}

// 检查投保单位是否有第三方id

export function CheckThirdlyUnit($this) {
    let sendData = {
        unitId: $this.form.insuredCompanyId,
        insureCompanyId:
            $this.type != 1
                ? $this.detail.insuranceCompanyId
                : $this.detail.insureProductCompanyId,
    };
    // 检查是否有第三方投保单位信息
    $this.$api.Insurance.CheckThirdlyUnit(sendData).then((res) => {
        if (res.error === false) {

            let check = res.data;
            // 获取系统的投保单位信息
            if (check) {
                $this.insuredCompanyId = res.data.thirdlyId;
                if (uniqueFalg == zy) {
                    zhongyi.OrderPrePerson($this)
                }
            } else {
                let sendData = {
                    id: $this.form.passivityInsuredCompanyId,
                };
                InsureUnitDetail(sendData, $this);

            }
        } else {
            $this.submitLoading = false;
            $this.$message.error(res.msg);
        }
    });
}

//获取系统投保单位详情
export function InsureUnitDetail(sendData, $this) {
    $this.$api.Insurance.InsureUnitDetail(sendData).then((res) => {
      
        if (res.error == false) {
            $this.submitLoading = false;
            if (uniqueFalg == zy) {
                zhongyi.EnterpriseEdit(res.data, res.data.id, $this);
            }
        } else {
            $this.submitLoading = false;
            $this.$message.error(res.msg);
        }
    });
}

//匹配第三方单位信息
export function MatchingUnitInfo(thirdlyId, unitId, $this) {
    let sendData = {
        insureCompanyId: $this.detail.insuranceCompanyId,
        unitId: unitId,
        thirdlyId: thirdlyId.data,
    };
    $this.$api.Insurance.MatchingUnitInfo(sendData).then((res) => {
      
        if (res.error === false) {
            $this.submitLoading = false;
        } else {
            $this.submitLoading = false;
            $this.$message.error(res.msg);
        }
    });
}

//新增订单或提交已保存的订单
export function creat_submit($this) {
    $this.$confirm(
        "确认提交订单吗?",
        "提示",
        {
            confirmButtonText: "确 认",
            cancelButtonText: "关 闭",
            type: "warning",
        }
    )
        .then(() => {
            $this.submitLoading = true;
            let sendData = {
                insuredCompanyId: $this.form.insuredCompanyId,
                insuredCompanyName: $this.$refs.myCompany.selected.label,
                insureProductCompanyName: $this.detail.insuranceCompanyName,
                insureProductCompanyId: $this.detail.insuranceCompanyId,
                passivityInsuredCompanyId: $this.form.passivityInsuredCompanyId,
                passivityInsuredCompanyName:
                    $this.$refs.myCompany2.selected.label,
                startDate: $this.form.startDate,
                thirdlyProductId: $this.detail.thirdlyId,
                endDate: $this.form.endDate,
                ProductExpandInfo: $this.detail.sumInsured || $this.detail.productExpandInfo,
                insuranceProductId:
                    $this.type != 1
                        ? $this.detail.id
                        : $this.detail.insuranceProductId,
                insureWay: $this.form.insureWay,
                insureWayText: $this.form.insureWay == 2 ? "年" : "月",
                insuranceOrderTheInsuredList: $this.tableData,
                state: 1,
            };

            if ($this.$route.query.id) {
                sendData.id = $this.$route.query.id;
            }
            $this.$api.Insurance[
                $this.type != 1 ? "InsuranceCompanyCreateOrder" : "SubmitData"
            ](sendData).then((res) => {
                $this.submitLoading = false;

                if (res.error === false) {
                    if (uniqueFalg == zy) {
                        SynchronizationThirdlyKeyVal(res.data, $this);
                    } else {
                        $this.$message.success("提交成功");
                        $this.$router.replace("/insuranceOrders");
                    }
                } else {
                    $this.$message.error(res.msg);
                }
            });
        })
        .catch(() => { });
}

// 存储第三方
export function SynchronizationThirdlyKeyVal(orderNo, $this) {
    let sendData = {
        orderNo: orderNo,
        thirdpartyInsuranceKey: $this.thirdpartyInsuranceKey,
    };

    $this.$api.Insurance.SynchronizationThirdlyKeyVal(sendData).then((res) => {
      
        if (res.error == false) {
            $this.$message.success("提交成功");
            $this.$router.replace("/insuranceOrders");
            if (uniqueFalg == zy) {
                zhongyi.editWeb($this, orderNo)
            }
            $this.orderFlag = true;
        } else {
            $this.submitLoading = false;
            $this.$message.error(res.msg);
        }
    });
}


//刷新状态
export function commitRefresh($this, i) {
    if (uniqueFalg == zy) {

    }
}